import React, { useState, useEffect, useRef } from "react";
import Select, { components } from "react-select";

const CustomControl = (props) => {
  const { selectProps } = props;

  const handleOpen = (e) => {
    e.stopPropagation();

    setTimeout(() => {
      const isOpening = selectProps.openSelectId !== selectProps.selectId;

      requestAnimationFrame(() => {
        document.querySelector(`#select-input-${selectProps.selectId}`)?.focus();
        if (isOpening) {
          selectProps.setOpenSelectId(selectProps.selectId);
          selectProps.setHasHoveredOption?.(false); // <-- RESET HERE
        } else {
          selectProps.setOpenSelectId(null);
          selectProps.setHasHoveredOption?.(false); // <-- RESET HERE
        }
      });

    }, 0);
  };

  return (
    <div onMouseDown={handleOpen} onTouchEnd={handleOpen}>
      <components.Control {...props} />
    </div>
  );
};

const CustomOption = (props) => {
  const { data, innerRef, innerProps, isSelected, isFocused, selectProps } = props;
  const [isHovered, setIsHovered] = React.useState(false);

  const isFirstOption = selectProps.options?.[0] === data;

  React.useEffect(() => {
    if (isHovered) {
      selectProps.setHasHoveredOption?.(true);
    }
  }, [isHovered]);

  return (
    <div
      ref={innerRef}
      {...innerProps}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: isHovered
          ? '#556ee6'
          : isSelected && !selectProps.hasHoveredOption
          ? '#556ee6'
          : 'white',
        color: isHovered
          ? 'white'
          : isSelected && !selectProps.hasHoveredOption
          ? 'white'
          : '#495057',
        fontWeight: isSelected ? 'normal' : 'normal',
        padding: '10px',
      }}
    >
      {data.label}
    </div>
  );
};

const StatusSelect = ({
  value,
  onChange,
  options,
  selectId,
  openSelectId,
  setOpenSelectId,
}) => {

  const domInputRef = useRef(null);
  const inputRef = useRef(null);
  const [hasHoveredOption, setHasHoveredOption] = useState(false);
  useEffect(()=>{
    //console.log('hasHoveredOption:', hasHoveredOption);
  },[hasHoveredOption])

  return (
    <div onMouseLeave={() => {setHasHoveredOption(false)}}>
      <Select
        value={options.find(opt => opt.value === value)}
        onChange={(selected) => {onChange(selected.value)}}
        options={options}
        isSearchable={false}
        menuIsOpen={openSelectId === selectId}
        onMenuClose={() => {
          setHasHoveredOption(false); // reset on close
          setOpenSelectId(null);
        }}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        selectId={selectId}
        openSelectId={openSelectId}
        setOpenSelectId={setOpenSelectId}
        hasHoveredOption={hasHoveredOption}
        setHasHoveredOption={setHasHoveredOption}
        inputId={`select-input-${selectId}`}

        styles={{
          menuPortal: base => ({ ...base, zIndex: 999 }),
          menu: (base) => ({
            ...base,
            backgroundColor: 'white',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            marginTop: '0px',
          }),
          control: (base, state) => ({
            ...base,
            zIndex: state.menuIsOpen ? 10 : 1,
            position: 'relative',
            boxShadow: 'none',
            '&:hover': {
              borderColor: '#ced4da',
            },
          }),
        }}
        components={{
          DropdownIndicator: null,
          IndicatorSeparator: null,
          Control: CustomControl,
          Option: CustomOption,
        }}
      />
    </div>
  );
};

export default StatusSelect;
